import React from 'react'
import type { CommunityThreadContextType } from '../services/communityThreadNotificationsService'
import {
  clearCommunityThreadPresence,
  setCommunityThreadPresence,
} from '../services/communityThreadPresenceService'

type UseCommunityThreadPresenceReporterParams = {
  active: boolean
  contextType: CommunityThreadContextType
  contextId: number | null
}

function normalizeContextId(raw: number | null): number | null {
  const id = Number(raw)
  if (!Number.isFinite(id) || id <= 0) return null
  return Math.floor(id)
}

export function useCommunityThreadPresenceReporter({
  active,
  contextType,
  contextId,
}: UseCommunityThreadPresenceReporterParams) {
  const safeContextId = React.useMemo(() => normalizeContextId(contextId), [contextId])

  React.useEffect(() => {
    if (!active || !safeContextId) {
      clearCommunityThreadPresence()
      return
    }

    setCommunityThreadPresence({ contextType, contextId: safeContextId })

    return () => {
      clearCommunityThreadPresence()
    }
  }, [active, contextType, safeContextId])
}

